<template>
  <li class="nav-item">
    <router-link
      :to="{ name: link.name }"
      @click.native="linkClick"
      class="nav-link"
    >
      <template>
        <i :class="link.icon"></i>
        <span class="nav-link-text">{{ link.label }}</span>
      </template>
    </router-link>
  </li>
</template>
<script>
export default {
  name: "sidebar-item",
  props: {
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: []
        };
      },
      description:
        "Sidebar link. Can contain name, path, icon and other attributes. See examples for more info"
    }
  },
  inject: {
    autoClose: {
      default: true
    }
  },
  data() {
    return {
      children: [],
      collapsed: true
    };
  },
  methods: {
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        // this.$sidebar.doPinSidebar(!this.$sidebar.pinSidebar);
      }
    }
  }
};
</script>
